import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import FilterSearchAddBar from '../../../UserScreen/InventoryPage/InventorySettings/components/FilterSearchAddBar/FilterSearchAddBar';
import LanCardComponent from './Components/LanCardComponent';
import NetworkTable from '../../../UserScreen/InventoryPage/InventorySettings/components/InterfacesTable/NetworkTable/NetworkTable';
import { ColumnConfig, ColumnType, NetworkTableRow } from '../../../UserScreen/InventoryPage/InventorySettings/components/InterfacesTable/NetworkTable/NetworkTable';
import Box from '@mui/material/Box';
import { getTrendsLanUsageTopWidgetUsageData, getTrendsLanNetworkTableData, getTrendsLanClientTableData, getLanNetworkTableCount, getLanClientTableCount, getLanWifiClientTable, getLanWifiClientTableCount, getLanWifiApClientTable, getLanWifiApClientTableCount, getTrendsLanUsageWifiTopWidgetUsageData } from '../../../actions/Users/authenticateTrends';
import { GET_TRENDS_LAN_USAGE_TOPWIDGET_USAGE, GET_TRENDS_LAN_USAGE_WIFI_TOPWIDGET_USAGE } from '../../../actions/types';
import { Paper, Typography, IconButton, Checkbox, Button, FormControl, InputLabel } from '@mui/material';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import _ from 'lodash';
import { getDecodeURI, getEncodedURI, readableBytesAsGB, readableBytesFormat } from '../../../utils/util';

type LanCardComponentProps = {
  leftCaption: string;
  customDisplayText: string;
  percentage?: number;
  unit?: string;
};

const LanCharts: React.FC<any> = ({ getTrendsLanNetworkTableData, getTrendsLanClientTableData, getTrendsLanUsageTopWidgetUsageData, authReducer, trendsReducer, getLanNetworkTableCount, getLanClientTableCount, lanNetworkCount, // ✅ add this
  lanClientCount, getLanWifiClientTable, getLanWifiClientTableCount, lanWifiClientCount, getLanWifiApClientTable, getLanWifiApClientTableCount, lanWifiApClientCount, getTrendsLanUsageWifiTopWidgetUsageData, location, history }) => {
  const dispatch = useDispatch();

  const rawColumns: ColumnConfig[] = [
    { label: 'Network Name', key: 'network_name', type: ColumnType.text, sortable: true, maxWidth: '120px', status: 'active', order: 3 },
    { label: 'Site', key: 'site_name', type: ColumnType.hyperlinkText, sortable: true, maxWidth: '140px', status: 'active', order: 1 },
    { label: 'Device Name', key: 'device', type: ColumnType.text, formatPlain: true, sortable: true, maxWidth: '140px', status: 'active', order: 2 },
    { label: 'VLAN ID', key: 'vlan_id', type: ColumnType.text, sortable: true, maxWidth: '90px', status: 'active', order: 5 },
    { label: 'Connected Devices', key: 'no_of_clients', type: ColumnType.text, sortable: true, maxWidth: '90px', status: 'active', order: 6 },
    { label: 'Usage (GB)', key: 'usage_total', type: ColumnType.text, sortable: true, maxWidth: '50px', status: 'active', order: 7, formatAsGB: true },
    { label: 'Upload (GB)', key: 'upload_total', type: ColumnType.text, sortable: true, maxWidth: '50px', status: 'active', order: 8, formatAsGB: true },
    { label: 'Download (GB)', key: 'download_total', type: ColumnType.text, sortable: true, maxWidth: '70px', status: 'active', order: 9, formatAsGB: true },
    { label: 'Network IP/CIDR', key: 'networkCIDR', type: ColumnType.text, sortable: true, maxWidth: '120px', status: 'active', order: 4 },
    // { label: 'LAN Alert', key: 'test', type: ColumnType.text, sortable: true, maxWidth: '106px', status: 'active', order: 10 },
  ];

  const columns: ColumnConfig[] = rawColumns;

  const rawClientColumns: ColumnConfig[] = [
    { label: 'Site', key: 'site_name', type: ColumnType.hyperlinkText, sortable: true, maxWidth: '90px', status: 'active', order: 1 },
    { label: 'Device', key: 'device_name', type: ColumnType.text, formatPlain: true, sortable: true, maxWidth: '90px', status: 'active', order: 2 },
    { label: 'Interface', key: 'interface_name', type: ColumnType.text, sortable: true, maxWidth: '80px', status: 'active', order: 3 },
    { label: 'Network Ip/CIDR', key: 'network_cidr', type: ColumnType.text, formatPlain: true, sortable: true, maxWidth: '80px', status: 'active', order: 5 },
    { label: 'VLAN ID', key: 'vlan_id', type: ColumnType.text, sortable: true, maxWidth: '50px', status: 'active', order: 6 },
    { label: 'Device ID', key: 'device_id', type: ColumnType.text, formatPlain: true, sortable: true, maxWidth: '90px', status: 'active', order: 7 },
    { label: 'Device IP', key: 'ip_address', type: ColumnType.text, formatPlain: true, sortable: true, maxWidth: '80px', status: 'active', order: 8 },
    { label: 'MAC Address', key: 'mac_address', type: ColumnType.text, formatPlain: true, sortable: true, maxWidth: '80px', status: 'active', order: 8 },
    { label: 'Hostname', key: 'hostname', type: ColumnType.text, formatPlain: true, sortable: true, maxWidth: '80px', status: 'active', order: 8 },
    { label: 'Network Name', key: 'network_name', type: ColumnType.text, sortable: true, maxWidth: '80px', status: 'active', order: 4 },
    { label: 'Usage (GB)', key: 'usage_total', type: ColumnType.text, sortable: true, maxWidth: '50px', status: 'active', order: 9, formatAsGB: true },
    { label: 'Download (GB)', key: 'download_total', type: ColumnType.text, sortable: true, maxWidth: '70px', status: 'active', order: 11, formatAsGB: true },
    { label: 'Upload (GB)', key: 'upload_total', type: ColumnType.text, sortable: true, maxWidth: '50px', status: 'active', order: 10, formatAsGB: true },
  ];

  const clientColumns: ColumnConfig[] = rawClientColumns;

  const rawWifiClientColumns: ColumnConfig[] = [
    { label: 'SSID', key: 'SSID', type: ColumnType.text, formatPlain: true, sortable: true, maxWidth: '140px', status: 'active', order: 7 },
    { label: 'Site', key: 'site_name', type: ColumnType.hyperlinkText, sortable: true, maxWidth: '100px', status: 'active', order: 1 },
    { label: 'Device', key: 'device_name', type: ColumnType.text, formatPlain: true, sortable: true, maxWidth: '100px', status: 'active', order: 2 },
    { label: 'Radio (GHz)', key: 'radio', type: ColumnType.text, sortable: true, maxWidth: '50px', status: 'active', order: 3 },
    { label: 'Band-Channel', key: 'channel', type: ColumnType.text, sortable: true, maxWidth: '60px', status: 'active', order: 4 },
    { label: 'Channel Width', key: 'channel_width', type: ColumnType.text, sortable: true, maxWidth: '60px', status: 'active', order: 5 },
    { label: 'TX Power (dBm)', key: 'tx_power', type: ColumnType.text, sortable: true, maxWidth: '60px', status: 'inactive', order: 6 },
    { label: 'CLIENT SINR (dBm)', key: 'SINR', type: ColumnType.text, sortable: true, maxWidth: '70px', status: 'active', order: 8 },
    { label: 'Client Rx/Tx Rate (Mbps)', combinedColumnList: ["rx_bitrate", "tx_bitrate"], columnListSeperator: " / ", key: 'test', type: ColumnType.combinedColumn, sortable: false, maxWidth: '90px', status: 'active', order: 9 },
    { label: 'Client MAC', key: 'mac_address', type: ColumnType.text, formatPlain: true, sortable: true, maxWidth: '120px', status: 'active', order: 10 },
    { label: 'Client IP', key: 'ip_address', type: ColumnType.text, formatPlain: true, sortable: true, maxWidth: '110px', status: 'active', order: 11 },
    { label: 'Client Alias', key: 'hostname', type: ColumnType.text, formatPlain: true, sortable: true, maxWidth: '120px', status: 'active', order: 12 },
    { label: 'Usage (GB)', key: 'usage_total', type: ColumnType.text, sortable: true, maxWidth: '50px', status: 'active', order: 13, formatAsGB: true },
    { label: 'Upload (GB)', key: 'upload_total', type: ColumnType.text, sortable: true, maxWidth: '50px', status: 'active', order: 14, formatAsGB: true },
    { label: 'Download (GB)', key: 'download_total', type: ColumnType.text, sortable: true, maxWidth: '50px', status: 'active', order: 15, formatAsGB: true }
  ];

  const wifiClientColumns: ColumnConfig[] = rawWifiClientColumns;
  
  const rawWifiApClientColumns: ColumnConfig[] = [
    { label: 'Site', key: 'site_name', type: ColumnType.hyperlinkText, sortable: true, maxWidth: '140px', status: 'active', order: 1 },
    { label: 'Device', key: 'device_name', type: ColumnType.text, formatPlain: true, sortable: true, maxWidth: '140px', status: 'active', order: 2 },
    { label: 'Radio (GHz)', key: 'radio', type: ColumnType.text, sortable: true, maxWidth: '50px', status: 'active', order: 3 },
    { label: 'Channel', key: 'channel', type: ColumnType.text, sortable: true, maxWidth: '70px', status: 'active', order: 4 },
    { label: 'Channel Width', key: 'channel_width', type: ColumnType.text, sortable: true, maxWidth: '70px', status: 'active', order: 5 },
    { label: 'TX Power (dBm)', key: 'tx_power', type: ColumnType.text, sortable: true, maxWidth: '60px', status: 'active', order: 6 },
    { label: 'SSID', key: 'SSID', type: ColumnType.text, formatPlain: true, sortable: true, maxWidth: '140px', status: 'active', order: 7 },
    { label: 'AP SINR (dBm)', key: 'SINR', type: ColumnType.text, sortable: true, maxWidth: '70px', status: 'active', order: 8 },
    { label: 'Clients', key: 'client', type: ColumnType.text, sortable: true, maxWidth: '70px', status: 'active', order: 9 },
    { label: 'Usage (GB)', key: 'usage_total', type: ColumnType.text, sortable: true, maxWidth: '50px', status: 'active', order: 10, formatAsGB: true },
    { label: 'Upload (GB)', key: 'upload_total', type: ColumnType.text, sortable: true, maxWidth: '50px', status: 'active', order: 11, formatAsGB: true },
    { label: 'Download (GB)', key: 'download_total', type: ColumnType.text, sortable: true, maxWidth: '50px', status: 'active', order: 12, formatAsGB: true }
  ];

  const wifiApClientColumns: ColumnConfig[] = rawWifiApClientColumns;

  const [filters, setFilters] = React.useState<boolean>(false);
  const [searchValue, setSearchValue] = React.useState<string>('');
  const [networkTableData, setNetworkTableData] = useState<NetworkTableRow[]>([]);
  const [clientTableData, setClientTableData] = useState<NetworkTableRow[]>([]);
  const [wifiClientTableData, setWifiClientTableData] = useState<NetworkTableRow[]>([]);
  const [wifiApClientTableData, setWifiApClientTableData] = useState<NetworkTableRow[]>([]);
  const [selectedTopic, setSelectedTopic] = useState<'network' | 'client' | 'wi-fi-client' | 'ap'>('network');
  const [isLoading, setIsLoading] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState(
    columns.filter(col => col.status === 'active').map(col => col.key)
  );
  const [visibleClientColumns, setVisibleClientColumns] = useState(
    clientColumns.filter(col => col.status === 'active').map(col => col.key)
  );
  const [visibleWifiClientColumns, setVisibleWifiClientColumns] = useState(
    wifiClientColumns.filter(col => col.status === 'active').map(col => col.key)
  );
  const [visibleWifiApClientColumns, setVisibleWifiApClientColumns] = useState(
    wifiApClientColumns.filter(col => col.status === 'active').map(col => col.key)
  );

  const [tempVisibleColumns, setTempVisibleColumns] = useState<(keyof NetworkTableRow)[]>(visibleColumns as (keyof NetworkTableRow)[]);
  const [tempVisibleClientColumns, setTempVisibleClientColumns] = useState<(keyof NetworkTableRow)[]>(visibleClientColumns as (keyof NetworkTableRow)[]);
  const [tempVisibleWifiClientColumns, setTempVisibleWifiClientColumns] = useState<(keyof NetworkTableRow)[]>(visibleWifiClientColumns as (keyof NetworkTableRow)[]);
  const [tempVisibleWifiApClientColumns, setTempVisibleWifiApClientColumns] = useState<(keyof NetworkTableRow)[]>(visibleWifiApClientColumns as (keyof NetworkTableRow)[]);

  const [filteredNetworkData, setFilteredNetworkData] = useState<NetworkTableRow[]>([]);
  const [filteredClientData, setFilteredClientData] = useState<NetworkTableRow[]>([]);
  const [filteredWifiClientData, setFilteredWifiClientData] = useState<NetworkTableRow[]>([]);
  const [filteredWifiApClientData, setFilteredWifiApClientData] = useState<NetworkTableRow[]>([]);


  const [lanCardData, setLanCardData] = useState<LanCardComponentProps[]>([
    { leftCaption: "Usage", customDisplayText: "0 GB" },
    { leftCaption: "Networks", customDisplayText: "0" },
    { leftCaption: "Clients", customDisplayText: "0" },
  ]);
  const [lanWifiCardData, setLanWifiCardData] = useState<LanCardComponentProps[]>([
    { leftCaption: "Usage", customDisplayText: "0 GB" },
    { leftCaption: "AP", customDisplayText: "0" },
    { leftCaption: "SSID", customDisplayText: "0" },
    { leftCaption: "Clients", customDisplayText: "0" },
    // { leftCaption: "Alerts", customDisplayText: "0" }
  ]);
  const [useApiSearch, setUseApiSearch] = useState<boolean>(true); 

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const lanFilterContent = (
    <Paper
      elevation={3}
      sx={{
        position: 'absolute',
        top: '40px',
        left: 0,
        zIndex: 10,
        minWidth: 250,
        background: '#fff',
        borderRadius: 2,
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
        p: 2,
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography fontWeight={400}>Filters</Typography>
        <IconButton size="small" onClick={() => setFilters(false)}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Box display="flex" flexDirection="column" gap={0.1} mb={2}>
        <FormControl fullWidth size="small">
          <InputLabel id="column-select-label">Columns</InputLabel>
          <Select
            labelId="column-select-label"
            multiple
            value={selectedTopic === 'network' ? tempVisibleColumns : selectedTopic == 'client' ? tempVisibleClientColumns : selectedTopic == 'wi-fi-client' ? tempVisibleWifiClientColumns : tempVisibleWifiApClientColumns}
            onChange={(e) => {
              const value = e.target.value as string[];
              const setter = selectedTopic === 'network'
                ? setTempVisibleColumns
                : selectedTopic == 'client' 
                ? setTempVisibleClientColumns 
                : selectedTopic == 'wi-fi-client' 
                ? setTempVisibleWifiClientColumns
                : setTempVisibleWifiApClientColumns;

              setter(value as (keyof NetworkTableRow)[]);
            }}

            input={<OutlinedInput label="Columns" />}
            renderValue={(selected) => {
              const sourceColumns = selectedTopic === 'network' ? columns : selectedTopic == 'client' ? clientColumns : selectedTopic == 'wi-fi-client' ? wifiClientColumns : wifiApClientColumns;
              const labels = (selected as string[]).map((key) => {
                const col = sourceColumns.find(c => c.key === key);
                return col?.label ?? key;
              });

              if (labels.length === 0) return <em>Select columns</em>;

              const labelText =
                labels.length === 1 ? labels[0] : `${labels[0]} +${labels.length - 1} ...`;

              return (
                <Chip
                  label={labelText}
                  size="small"
                  sx={{
                    backgroundColor: '#f2f2f2',
                    fontSize: '13px',
                    height: '24px',
                    borderRadius: '16px',
                    maxWidth: '100%',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                  }}
                />
              );
            }}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 300,
                },
              },
            }}
          >
            {(selectedTopic === 'network' ? columns : selectedTopic == 'client' ? clientColumns : selectedTopic == 'wi-fi-client' ? wifiClientColumns : wifiApClientColumns)
              .filter(col => col.status !== 'internal')
              .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))  // 
              .map((col) => (
                <MenuItem
                  key={col.key}
                  value={col.key}
                >
                  <Checkbox
                    size="small"
                    checked={
                      selectedTopic === 'network'
                        ? tempVisibleColumns.includes(col.key as keyof NetworkTableRow)
                        : selectedTopic == 'client' ? tempVisibleClientColumns.includes(col.key as keyof NetworkTableRow)
                        : selectedTopic == 'wi-fi-client' ? tempVisibleWifiClientColumns.includes(col.key as keyof NetworkTableRow)
                        : tempVisibleWifiApClientColumns.includes(col.key as keyof NetworkTableRow)
                    }
                  />
                  <Typography variant="body2" sx={{ fontSize: '13px' }}>
                    {col.label}
                  </Typography>
                </MenuItem>
              ))}

          </Select>
        </FormControl>
      </Box>
      <Box display="flex" justifyContent="space-between" mt={1}>
        <Button
          variant="text"
          onClick={() => {
            const defaultVisible = columns
              .filter(col => col.status === 'active')
              .map(col => col.key) as (keyof NetworkTableRow)[];
            const defaultClientVisible = clientColumns
              .filter(col => col.status === 'active')
              .map(col => col.key) as (keyof NetworkTableRow)[];
            const defaultWifiClientVisible = wifiClientColumns
              .filter(col => col.status === 'active')
              .map(col => col.key) as (keyof NetworkTableRow)[];
            const defaultWifiApClientVisible = wifiApClientColumns
              .filter(col => col.status === 'active')
              .map(col => col.key) as (keyof NetworkTableRow)[];

            setTempVisibleColumns(defaultVisible);
            setTempVisibleClientColumns(defaultClientVisible);
            setTempVisibleWifiClientColumns(defaultWifiClientVisible)
            setTempVisibleWifiApClientColumns(defaultWifiApClientVisible)


            setVisibleColumns(defaultVisible);
            setVisibleClientColumns(defaultClientVisible);
            setVisibleWifiClientColumns(defaultWifiClientVisible)
            setVisibleWifiApClientColumns(defaultWifiApClientVisible)


            setFilters(false);
          }}
          sx={{ color: '#666' }}
        >
          Reset
        </Button>


        <Button
          variant="contained"
          onClick={() => {
            setFilters(false);
            setVisibleColumns(tempVisibleColumns);
            setVisibleClientColumns(tempVisibleClientColumns);
            setVisibleWifiClientColumns(tempVisibleWifiClientColumns)
            setVisibleWifiApClientColumns(tempVisibleWifiApClientColumns)
          }}
          sx={{ backgroundColor: '#264C86' }}
        >
          Apply
        </Button>

      </Box>
    </Paper>
  );

  const [sortBy, setSortBy] = useState<string>('usage_total'); 
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('desc'); 
  const [vessels, setVessels] = useState([]);

  const trendsLanTableData = authReducer?.trendsLanTableData?.[selectedTopic];

  useEffect(() => {
    if (_.isEmpty(authReducer?.getVesselsListing))
      return;
    let vessels = [];
    const filteredVessels = authReducer?.filteredVessels;
    if (filteredVessels && filteredVessels.length > 0) {
      vessels = filteredVessels;
    } else {
      vessels = authReducer?.getVesselsListing?.locations;
    }
    setVessels(vessels);
  }, [authReducer?.getVesselsListing, authReducer?.filteredVessels])

  useEffect(() => {
      if (!useApiSearch) return; 
    const startDate = authReducer?.newSummaryStartDate;
    const endDate = authReducer?.newSummaryEndDate;
    if (!startDate || !endDate || vessels?.length == 0) return;
    if(selectedTopic == 'network' || selectedTopic == 'client') {
    getTrendsLanUsageTopWidgetUsageData(vessels, startDate, endDate, searchValue);
    } else if(selectedTopic == 'wi-fi-client' || selectedTopic == 'ap') {
      getTrendsLanUsageWifiTopWidgetUsageData(vessels, startDate, endDate, searchValue);
    }
    if(selectedTopic == 'network') {
      getTrendsLanNetworkTableData(vessels, startDate, endDate, page-1, rowsPerPage, searchValue, sortBy, sortOrder);
      getLanNetworkTableCount(vessels, startDate, endDate, searchValue)
    }
    else if(selectedTopic == 'client') {
      getTrendsLanClientTableData(vessels, startDate, endDate, page-1, rowsPerPage, sortBy, sortOrder, searchValue);
      getLanClientTableCount(vessels, startDate, endDate, searchValue)
    } else if (selectedTopic == 'wi-fi-client') {
      getLanWifiClientTable(vessels, startDate, endDate, page-1, rowsPerPage, sortBy, sortOrder, searchValue)
      getLanWifiClientTableCount(vessels, startDate, endDate, searchValue)
    } else if (selectedTopic == 'ap') {
      getLanWifiApClientTable(vessels, startDate, endDate, page-1, rowsPerPage, sortBy, sortOrder, searchValue)
      getLanWifiApClientTableCount(vessels, startDate, endDate, searchValue)
    }

  }, [vessels, authReducer?.newSummaryStartDate, authReducer?.newSummaryEndDate, page, rowsPerPage, selectedTopic, searchValue, useApiSearch, sortBy, sortOrder]);

  useEffect(() => {
    const rows = trendsLanTableData?.data;

    if (!Array.isArray(rows)) {
      setNetworkTableData([]);
      setClientTableData([]);
      setWifiClientTableData([]);
      setWifiApClientTableData([]);
      return;
    };

    let mappedData: NetworkTableRow[] = [];

    if (selectedTopic === 'network') {
      mappedData = rows.map((row, index) => ({
        id: `${(page * rowsPerPage) + index + 1}`,
        network_name: row.network_name,
        networkCIDR: row.networkCIDR,
        site_name: row.site_name,
        k4Id: row.k4Id || '',
        device: row.device,
        vlan_id: row.vlan_id || 'N/A',
        no_of_clients: `${row.no_of_clients}`,
        usage_total: `${row.usage_total}`,
        upload_total: `${row.upload_total}`,
        download_total: `${row.download_total}`,
        uploadRate: `${row.upload_rate}`,
        downloadRate: `${row.download_rate}`,
      }));

      setNetworkTableData(mappedData);
      setFilteredNetworkData(mappedData); 

    } else if (selectedTopic === 'client') {
      mappedData = rows.map((row, index) => ({
        id: `${(page * rowsPerPage) + index + 1}`,
        site_name: row.site_name || '',
        k4Id: row.k4Id || '',
        device_name: row.device_name || '',
        interface_name: row.interface_name || '',
        network_cidr: row.network_cidr || '',
        device_id: row.device_id || '',
        vlan_id: row.vlan_id || 'N/A',
        ip_address: row.ip_address || '',
        mac_address: row.mac_address || '',
        hostname: row.hostname || '',
        network_name: row.network_name || '',
        usage_total: `${row.usage_total ?? 0}`,
        download_total: `${row.download_total ?? 0}`,
        upload_total: `${row.upload_total ?? 0}`,
      }));

      setClientTableData(mappedData);
      setFilteredClientData(mappedData); 
    } else if (selectedTopic == 'wi-fi-client') {
      mappedData = rows.map((row, index) => ({
        id: `${(page * rowsPerPage) + index + 1}`,
        SSID: row.SSID || '',
        site_name: row.site_name || '',
        k4Id: row.k4Id || '',
        device_name: row.device_name || '',
        channel: row.channel || '',
        radio: row.radio == 'radio1' ? '5' : row.radio == 'radio0' ? '2.4' : '',
        tx_power: row.tx_power?.split(' ')[0] || '',
        SINR: row.SINR || '',
        channel_width: row.channel_width || '',
        rx_bitrate: Number(row.rx_bitrate?.split(' ')[0])?.toFixed(0) || '',
        tx_bitrate: Number(row.tx_bitrate?.split(' ')[0])?.toFixed(0) || '',
        mac_address: row.mac_address || '',
        ip_address: row.ip_address || '',
        hostname: row.hostname || '',
        usage_total: `${row.usage_total ?? 0}`,
        download_total: `${row.download_total ?? 0}`,
        upload_total: `${row.upload_total ?? 0}`,
      }));

      setWifiClientTableData(mappedData);
      setFilteredWifiClientData(mappedData); 
    } else {
      {
      mappedData = rows.map((row, index) => ({
        id: `${(page * rowsPerPage) + index + 1}`,
        SSID: row.SSID || '',
        site_name: row.site_name || '',
        k4Id: row.k4Id || '',
        device_name: row.device_name || '',
        channel: row.channel || '',
        radio: row.radio == 'radio1' ? '5' : row.radio == 'radio0' ? '2.4' : '',
        tx_power: row.tx_power?.split(' ')[0] || '',
        SINR: row.SINR || '',
        channel_width: row.channel_width || '',
        client: row.client || '',
        usage_total: `${row.usage_total ?? 0}`,
        download_total: `${row.download_total ?? 0}`,
        upload_total: `${row.upload_total ?? 0}`,
      }));

      setWifiApClientTableData(mappedData);
      setFilteredWifiApClientData(mappedData); 
    }
    }

    // setSearchValue('');
  }, [trendsLanTableData?.data, selectedTopic]);


  useEffect(() => {
    setPage(1);
  }, [selectedTopic]);


  useEffect(() => {
    const topWidgetData = authReducer?.getTrendsLanUsageTopWidgetUsage?.data;
    const wifiTopWidgetData = authReducer?.getTrendsLanUsageWifiTopWidgetUsage?.data;
    if (topWidgetData?.length) {
      const cardData = generateLanCardData(topWidgetData);
      setLanCardData(cardData);
      dispatch({type: GET_TRENDS_LAN_USAGE_TOPWIDGET_USAGE, payload: {}})
    }
    if (wifiTopWidgetData?.length) {
      const cardData = generateLanWifiCardData(wifiTopWidgetData);
      setLanWifiCardData(cardData);
      dispatch({type: GET_TRENDS_LAN_USAGE_WIFI_TOPWIDGET_USAGE, payload: {}})
    }
  }, [authReducer?.getTrendsLanUsageTopWidgetUsage, authReducer?.getTrendsLanUsageWifiTopWidgetUsage]);

  useEffect(() => {
    if (!useApiSearch) {
      const searchLower = searchValue.toLowerCase();
      const filterData = (data: NetworkTableRow[], visibleKeys: (keyof NetworkTableRow)[]) =>
        data.filter((row) =>
          visibleKeys.some((key) =>
            String(row[key] ?? '').toLowerCase().includes(searchLower)
          )
        );

      const visibleKeys = (selectedTopic === 'network'
        ? visibleColumns
        : selectedTopic == 'client' ? visibleClientColumns
          : selectedTopic == 'wi-fi-client' ? visibleWifiClientColumns
          : visibleWifiApClientColumns
      ).filter((key): key is keyof NetworkTableRow => key !== 'custom');

      if (selectedTopic === 'network') {
        setFilteredNetworkData(filterData(networkTableData, visibleKeys));
      } else if (selectedTopic == 'client') {
        setFilteredClientData(filterData(clientTableData, visibleKeys));
      } else if(selectedTopic == 'wi-fi-client') {
        setFilteredWifiClientData(filterData(wifiClientTableData, visibleKeys))
      } else {
        setFilteredWifiApClientData(filterData(wifiApClientTableData, visibleKeys))
      }
    }
  }, [
    searchValue,
    selectedTopic,
    useApiSearch, 
    networkTableData,
    clientTableData,
    wifiClientTableData,
    visibleColumns,
    visibleClientColumns,
    visibleWifiClientColumns
  ]);




  // useEffect(() => {
  //   setFilteredNetworkData(networkTableData);
  // }, [networkTableData]);

  // useEffect(() => {
  //   setFilteredClientData(clientTableData);
  // }, [clientTableData]);


  interface LanCardComponentProps {
  leftCaption: string;
  customDisplayText: string;
  unit?: string;
}

  const generateLanCardData = (data: any[]): LanCardComponentProps[] => {
    if (!data?.length) return [];
    const totals = data?.[0];
    const totalUsageDisplay = readableBytesFormat(totals.total_usage);
    return [
      {
        leftCaption: "Usage",
        customDisplayText: totalUsageDisplay,
      },
      {
        leftCaption: "Networks",
        customDisplayText: totals.total_networks,
      },
      {
        leftCaption: "Clients",
        customDisplayText: totals.total_clients,
      },
    ];
  };

  const generateLanWifiCardData = (data: any[]): LanCardComponentProps[] => {
    if (!data?.length) return [];
    const totals = data?.[0];
    console.log('totalstotals',totals)
    const totalUsageDisplay = totals?.total_usage > 0 ? readableBytesFormat(totals.total_usage) : '0 GB';
    return [
      { leftCaption: "Usage", customDisplayText: totalUsageDisplay },
      { leftCaption: "AP", customDisplayText: totals.total_aps },
      { leftCaption: "SSID", customDisplayText: totals.total_ssid },
      { leftCaption: "Clients", customDisplayText: totals.clients },
      // { leftCaption: "Alerts",customDisplayText: totals.total_clients},
    ];
  };

  const handleDownload = async () => {
    let data: NetworkTableRow[] = [];

    const startDate = authReducer?.newSummaryStartDate;
    const endDate = authReducer?.newSummaryEndDate;
    
    try {
      if (selectedTopic === 'network') {
        const resp = await getTrendsLanNetworkTableData(vessels, startDate, endDate, 0, lanNetworkCount, searchValue, sortBy, sortOrder, true);
        data = resp?.data?.data || [];
    } else if (selectedTopic === 'client') {
      const resp = await getTrendsLanClientTableData(vessels, startDate, endDate, 0, lanClientCount, sortBy, sortOrder, searchValue, true);
      data = resp?.data?.data || [];
    } else if (selectedTopic === 'wi-fi-client') {
      const resp = await getLanWifiClientTable(vessels, startDate, endDate, 0, lanWifiClientCount, sortBy, sortOrder, searchValue, true);
      data = resp?.data?.data || [];
    } else {
      const resp = await getLanWifiApClientTable(vessels, startDate, endDate, 0, lanWifiApClientCount, sortBy, sortOrder, searchValue, true);
      data = resp?.data?.data || [];
    }

    const activeColumns = (selectedTopic === 'network' ? columns : selectedTopic == 'client' ? clientColumns : selectedTopic == 'wi-fi-client' ? wifiClientColumns : wifiApClientColumns)
      .filter(col => (selectedTopic === 'network' ? visibleColumns : selectedTopic == 'client' ? visibleClientColumns : selectedTopic == 'wi-fi-client' ? visibleWifiClientColumns : visibleWifiApClientColumns).includes(col.key));

    const headers = activeColumns.map(col => col.label);
    const rows = data.map(row =>
      activeColumns.map(col => {
        let value: any = null;

        const combinedList: string[] = (col as any).combinedColumnList;
        const sep: string = (col as any).columnListSeperator || ' / ';
        if (Array.isArray(combinedList) && combinedList.length > 0) {
          const parts = combinedList.map((k) => {
            const v = row[k];
            const s = v === undefined || v === null ? '' : String(v);
            const raw = (s.split(' ')[0] || '').replace(/[^0-9.\-]/g, '');

            if (raw && !isNaN(Number(raw))) {
              return Math.round(Number(raw)).toString();
            }

            return s;
          });
          value = `="${parts.join(sep)}"`;
        } else {
          value = row[col.key as keyof typeof row];
        }

        if ((selectedTopic === 'wi-fi-client' || selectedTopic == 'ap') && col.key === 'radio') {
          value = value === 'radio1' ? '5' : value === 'radio0' ? '2.4' : '';
        }

        if (col.formatAsGB && value !== undefined && value !== null && !isNaN(Number(value))) {
          value = value ? readableBytesAsGB(Number(value), false) : 0;
        }
        
        return typeof value === 'string'
          ? `"${value.replace(/"/g, '""')}"`
          : value;
      }).join(',')
    );

    const csvContent = [headers.join(','), ...rows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', `LAN-${selectedTopic}-table.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading data:', error);
    }
  };

  console.log("lanNetworkCount:", lanNetworkCount);
  console.log("lanClientCount:", lanClientCount);

  const handleTopicChange = (tab) => {
    setSelectedTopic(tab);
    setNetworkTableData([]);
    setClientTableData([]);
    setWifiClientTableData([]);
    setWifiApClientTableData([]);
    setSortBy('usage_total');
    setSortOrder('desc');
    setPage(1);
    setSearchValue('')
  }

  const onHyperlinkClick = (key, value, row) => {
    {
      switch (key) {
        case "site_name":
          let params: any = getDecodeURI(location?.search);
          row && row.k4Id ? params.k4Ids = `${row.k4Id}:${row.site_name}` : delete params.k4Ids;
          delete params.page;
          delete params.limit;
          delete params.sort;
          delete params.sortOrder;
          delete params.search;
          history.push({ pathname: location.pathname, search: `?${getEncodedURI(params)}` });
          break;
        default:
          console.log("key: ", key);
      }
    }
  }

  return (
    <>
      <FilterSearchAddBar
        config={['filterButton', 'searchBar']}
        filters={filters}
        setFilters={setFilters}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        selectedSite={selectedTopic}
        siteButtonLabels={["Network", "Client", "Wi-Fi Client", "AP"]}
        onSiteChange={(val) => val !== selectedTopic && handleTopicChange(val as 'network' | 'client' | 'wi-fi-client')}
        showDownloadButton={trendsLanTableData?.data?.length > 0}
        onDownloadClick={handleDownload}
        controlHeight={32}
        filterDropdownContent={lanFilterContent}
      />
      <Box height="16px" />
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          rowGap: 2,
        }}
      >
        {(selectedTopic == 'network' || selectedTopic == 'client') && lanCardData.map((item, index) => (
          <LanCardComponent key={index} {...item} />
        ))}
        {(selectedTopic == 'wi-fi-client' || selectedTopic == 'ap') && lanWifiCardData.map((item, index) => (
          <LanCardComponent key={index} {...item} />
        ))}
      </Box>
      <Box sx={{ height: '25px' }} />

      {console.log("Trends Final data passed to table:", selectedTopic === 'network' ? filteredNetworkData : selectedTopic == 'client' ? filteredClientData : selectedTopic == 'wi-fi-client' ? filteredWifiClientData : filteredWifiApClientData)}

      {isLoading ? (
        <Box textAlign="center" py={4}>Loading data...</Box>
      ) : (

        <NetworkTable
          key={`${selectedTopic}-${page}-${rowsPerPage}`}
          data={
            useApiSearch
              ? selectedTopic === 'network' ? networkTableData : selectedTopic == 'client' ? clientTableData : selectedTopic == 'wi-fi-client' ? wifiClientTableData : wifiApClientTableData
              : selectedTopic === 'network' ? filteredNetworkData : selectedTopic == 'client' ? filteredClientData : selectedTopic == 'wi-fi-client' ? filteredWifiClientData : filteredWifiApClientData
          }
          columns={
            (selectedTopic === 'network' ? columns : selectedTopic == 'client' ? clientColumns : selectedTopic == 'wi-fi-client' ? wifiClientColumns : wifiApClientColumns)
              .filter(col => col.status !== 'internal')
              .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
          }
          visibleColumns={selectedTopic === 'network' ? visibleColumns : selectedTopic == 'client' ? visibleClientColumns : selectedTopic == 'wi-fi-client' ? visibleWifiClientColumns : visibleWifiApClientColumns}
          onActionClick={(type, key, row) => console.log(type, key, row)}
          onHyperlinkClick={onHyperlinkClick}
          enablePagination
          rowsPerPageOptions={[10, 15, 25]}
          defaultRowsPerPage={15}
          headingHeight={40}
          maxHeight={`calc(100vh - 370px)`}
          totalRowCount={
            selectedTopic === 'network'
              ? lanNetworkCount || filteredNetworkData.length
              : selectedTopic == 'client' ? lanClientCount || filteredClientData.length
              : selectedTopic == 'wi-fi-client' ? lanWifiClientCount || filteredWifiClientData.length
              : lanWifiApClientCount || filteredWifiApClientData.length
          }

          onPageChange={(newPage, limit) => {
            console.log("Trends Next button clicked. New Page:", newPage, "Limit:", limit);

            setPage(newPage);
            setRowsPerPage(limit); 
          }}
          onRowsPerPageChange={(limit) => {
            setPage(1); 
            setRowsPerPage(limit);
          }}

          page={page} 
          rowsPerPage={rowsPerPage} 

          onSortChange={(columnKey) => {
            const newOrder = columnKey === sortBy && sortOrder === 'asc' ? 'desc' : 'asc';
            setSortBy(columnKey);
            setSortOrder(newOrder);
            setPage(1); // Reset to first page
          }}

          sortBy={sortBy}
          sortOrder={sortOrder} 

        />)}

      <Box sx={{ height: '32px' }} />
      <Box sx={{ height: '55px' }} />
    </>
  );
};

const mapStateToProps = (state) => ({
  authReducer: state.authReducer,
  trendsReducer: state.trendsReducer,
  lanNetworkCount: state.authReducer.lanNetworkTableCount,
  lanClientCount: state.authReducer.lanClientTableCount,
  lanWifiClientCount: state.authReducer.lanWifiClientTableCount,
  lanWifiApClientCount: state.authReducer.lanWifiApClientTableCount
});

export default withRouter(
  connect(mapStateToProps, {
    getTrendsLanUsageTopWidgetUsageData,
    getTrendsLanNetworkTableData,
    getTrendsLanClientTableData,
    getLanNetworkTableCount,
    getLanClientTableCount,
    getLanWifiClientTable,
    getLanWifiClientTableCount,
    getLanWifiApClientTable,
    getLanWifiApClientTableCount,
    getTrendsLanUsageWifiTopWidgetUsageData
  })(LanCharts)
);